import React, { Component } from 'react';
// import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class About extends Component {


  render() {
    return (
      <h1>this is the About page</h1>
    )
  }
}

export default About;